import * as React from "react";
import { FunctionComponent } from "react";
import { getMarkClasses, PitMarks } from "./PitView";
import Stones from "./Stones";

// A store: the top player's on the left ("l"), the viewer's on the right ("r").
const StoreView: FunctionComponent<{
  index: number;
  stoneCount: number;
  side: "l" | "r";
  themeId: string;
  label: string;
  marks: PitMarks;
}> = ({ index, stoneCount, side, themeId, label, marks }) => (
  <div className={`store ${side}${getMarkClasses(marks)}`} role="img" aria-label={label}>
    <Stones count={stoneCount} seed={index * 3.1 + 7} themeId={themeId} />
    <span className="sbadge">{stoneCount}</span>
    {!!marks.preview && <span className="pvchip">{`+${marks.preview}`}</span>}
  </div>
);

export default StoreView;
